'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _RetirementPlanListContainer = require('./RetirementPlanListContainer.css');

var _RetirementPlanListContainer2 = _interopRequireDefault(_RetirementPlanListContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RetirementPlanListContainer = (_dec = (0, _reactCssModules2.default)(_RetirementPlanListContainer2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RetirementPlanListContainer, _Component);

  function RetirementPlanListContainer(props) {
    (0, _classCallCheck3.default)(this, RetirementPlanListContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RetirementPlanListContainer.__proto__ || (0, _getPrototypeOf2.default)(RetirementPlanListContainer)).call(this, props));

    _this.state = {
      title: 'Retirement plans',
      description: _config2.default.app.description,
      url: _config2.default.domain + _config2.default.routes.plans,
      viewAs: 0
    };
    return _this;
  }

  (0, _createClass3.default)(RetirementPlanListContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          'h1',
          { styleName: 'rplc-tl' },
          '401(k)s and similar retirement plans'
        ),
        _react2.default.createElement(
          'p',
          { styleName: 'rplc-p' },
          'We\'ve rated 50+ employer-offered retirement plans for investments in fossil fuels, deforestation, weapons, private prisons, and more.'
        ),
        _react2.default.createElement(_components.RetirementPlanGridTableWrap, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'content-wrap' },
            _react2.default.createElement(
              'h2',
              null,
              'How are these companies chosen?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We think every retirement plan should be rated on sustainability. Our goal is to expand this database to cover the S&P 500. We\'ve started with major companies that most people will recognize, covering hundreds of thousands of participants and billions in assets. But the sustainability issues with their retirement plans are not unique to these companies. Check back regularly to see if your employer has been added to our database.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Want us to rate the retirement plan of your employer? ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.contact,
                    title: 'Contact us',
                    xstrong: true
                  },
                  'Get in touch with us',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return RetirementPlanListContainer;
}(_react.Component)) || _class);
exports.default = RetirementPlanListContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RetirementPlanListContainer/RetirementPlanListContainer.js
// module id = 1497
// module chunks = 0